
import { BrowserRouter,Route,Routes } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import Home from "./componants/home";
import About from "./componants/aboutusComponants/about";
import Contact from "./componants/contact";
import Error from "./componants/errorpage";
import Blogs from "./componants/blogs";
// basic course start 
import BasicOfStockMarket from "./coursePages/basicCourse/basicOfStockMarket";
import EquityMarketEssentials from "./coursePages/basicCourse/EquityMarketEssentials";
import CoreConceptOfStockInvesting from "./coursePages/basicCourse/coreConceptOfStockInvesting";
import StockMarketForBiginners from "./coursePages/basicCourse/stockMarketForBiginners";
import FundamentalStockMarket from "./coursePages/basicCourse/fundamentalStockMarket";
import UnderstandigOfStockMarket from "./coursePages/basicCourse/underStandingOfstockMarket";
import NavigatingStockMarket from "./coursePages/basicCourse/navigatingStockMarket";
import BasicOfTechnicalAnalysis from "./coursePages/basicCourse/basicOfTechnicalAnalysis"; // basic course end

// intermideate course start 
import AdnacedOptionsAndFutureTrade from "./coursePages/intermideateCourse/advancedOptionAndFutureTrade";
import HowToTradeInFutureAndOptions from "./coursePages/intermideateCourse/howToTradeInFutureAndOptions";
import IntermideateOptionStratiges from "./coursePages/intermideateCourse/intermideateOptionStratigies";
import IntermideateStockMarket from "./coursePages/intermideateCourse/intermideateOptionTrading";
import IntroductionToOptionTrading from "./coursePages/intermideateCourse/introductionOptionTrading";
import MasteringOptionChain from "./coursePages/intermideateCourse/masteringOptionsChain";
import OptionsAnalysisMasterclass from "./coursePages/intermideateCourse/optionAnalysisMasterclass";
import OptionsTradingTechnique from "./coursePages/intermideateCourse/optionsTradingTechnique"; // intermideate course end here

// advanced course start form here

import ArtInvestingInMutualFunds from "./coursePages/advanceCourse/artInvestingInMutualFunds";
import ArtOfFutureAndOptions from "./coursePages/advanceCourse/artOfFutureAndOptios";
import FutureAndOptionAlchemy from "./coursePages/advanceCourse/futureAndOptionsAlchemy";
import HedgingHorizon from "./coursePages/advanceCourse/hedgingHorizons";
import MasteringMoneyManagement from "./coursePages/advanceCourse/masteringMoneyManagement";
import MasterWithPattern from "./coursePages/advanceCourse/masterWithPattern";
import TheEdge from "./coursePages/advanceCourse/theEdge";
import UnlockingMarketSecret from "./coursePages/advanceCourse/unlockingMarketSecret";

// technical courser start form here 

import BootstrapCourse from "./coursePages/technicalcourse/bootstrap";
import CLanguage from "./coursePages/technicalcourse/c";
import CppLanguage from "./coursePages/technicalcourse/cpp";
import DatabaseManagementMongoDB from "./coursePages/technicalcourse/databasemanagemenet";
import DsaWithCpp from "./coursePages/technicalcourse/dsacpp";
import FullStackWebDevelopment from "./coursePages/technicalcourse/fullstackwebdevelopment";
import CoreJava from "./coursePages/technicalcourse/java";
import JavaScript from "./coursePages/technicalcourse/javascript";
import MeanStack from "./coursePages/technicalcourse/meanstack";
import MernStack from "./coursePages/technicalcourse/mernstack";
import Python from "./coursePages/technicalcourse/python";
import ReactCourse from "./coursePages/technicalcourse/react";
import WebDesign from "./coursePages/technicalcourse/webdesign";
import ComputerNetworking from "./coursePages/technicalcourse/computernetworking";


import BasicCourse from "./componants/DropDownCourseComponents/basiccourse";
import AllCourse from "./componants/DropDownCourseComponents/allcourse";
import AdvanceCourse from "./componants/DropDownCourseComponents/advacedcourse";
import IntermideateCourse from "./componants/DropDownCourseComponents/intermideatecourse";
import TechnicalCourse from "./componants/DropDownCourseComponents/technicalcourse";

import InquiryFormPopup from "./componants/InquiryFormPopup";

// footer links pages starts form here 

 import Investment from "./componants/FooterLinksPages/productpages/investment";
 import TradingPlatform from "./componants/FooterLinksPages/productpages/tradingPlatform";
import TradingEducation from "./componants/FooterLinksPages/productpages/tradingEducation";
import WebDesignAndDevelopment from "./componants/FooterLinksPages/productpages/webDesignAndDevelopment";
import UxDesign from "./componants/FooterLinksPages/productpages/uiUxDesign";
import SEO from "./componants/FooterLinksPages/productpages/SEO";

//support branch 

import ProductAssistance from "./componants/FooterLinksPages/support/productassitance";
import TechnicalAssistance from "./componants/FooterLinksPages/support/technicalassistance";
import ClintService from "./componants/FooterLinksPages/support/clintservice";

// visit branch routes 
import Burari from "./componants/FooterLinksPages/visist/burari";
import LaxmiNagar from "./componants/FooterLinksPages/visist/laxminagar";

// features links

import PriceAndValue from "./componants/FooterLinksPages/Features/priceAndValue";
import HandsOnTraning from "./componants/FooterLinksPages/Features/handsOnTraning";
import InnovatinTechnique from "./componants/FooterLinksPages/Features/inovationTechnique";
import ExpertTranner from "./componants/FooterLinksPages/Features/expertTranners";
import ResourceMaterial from "./componants/FooterLinksPages/Features/ResourceMaterial";
import AOneTeaching from "./componants/FooterLinksPages/Features/AOneTeaching";

// enterprenour
import OnlineMarketer from "./componants/FooterLinksPages/Enterprener/onlinemarkerter";
import MarketManager from "./componants/FooterLinksPages/Enterprener/marketmanager";
import JoinOurTeam from "./componants/FooterLinksPages/Enterprener/joinOurTeam";


function App() {
  return (
    
   <>
       <BrowserRouter>
         <Routes>
          <Route path="/" element={<Home/>}></Route>
          <Route path="/about" element={<About/>}></Route>
          <Route path="/contact" element={<Contact/>}></Route>
          <Route path="/blogs" element={<Blogs/>}></Route>
          <Route path="*" element={<Error />} />
          <Route path="/basicOfStockMarket" element={<BasicOfStockMarket/>}/>
          <Route path="/equityMarketEssentials" element={<EquityMarketEssentials/>}/>
          <Route path="/coreConceptOfStockInvesting" element={<CoreConceptOfStockInvesting/>}/>
          <Route path="/stockMarketForBiginners" element={<StockMarketForBiginners/>}/>
          <Route path="/fundamentalStockMarket" element={<FundamentalStockMarket/>}/>
          <Route path="/understandingOfstockMarket" element={<UnderstandigOfStockMarket/>}/>
          <Route path="/navigatingStockMarket" element={<NavigatingStockMarket/>}/>
          <Route path="/basicOfTechnicalAnalysis" element={<BasicOfTechnicalAnalysis/>}/>

          <Route path="/advancedOptionAndFutureTrade" element={<AdnacedOptionsAndFutureTrade/>}/>
          <Route path="/howToTradeInFutureAndOptions" element={<HowToTradeInFutureAndOptions/>}/>
          <Route path="/intermideateOptionStratigies" element={<IntermideateOptionStratiges/>}/>
          <Route path="/intermideateOptionTrading" element={<IntermideateStockMarket/>}/>
          <Route path="/introductionOptionTrading" element={<IntroductionToOptionTrading/>}/>
          <Route path="/masteringOptionsChain" element={<MasteringOptionChain/>}/>
          <Route path="/optionAnalysisMasterclass" element={<OptionsAnalysisMasterclass/>}/>
          <Route path="/optionsTradingTechnique" element={<OptionsTradingTechnique/>}/>

          <Route path="artInvestingInMutualFunds" element={<ArtInvestingInMutualFunds/>}/>
          <Route path="/artOfFutureAndOptios" element={<ArtOfFutureAndOptions/>}/>
          <Route path="/futureAndOptionsAlchemy" element={<FutureAndOptionAlchemy/>}/>
          <Route path="/hedgingHorizons" element={<HedgingHorizon/>}/>
          <Route path="/masteringMoneyManagement" element={<MasteringMoneyManagement/>}/>
          <Route path="/masterWithPattern" element={<MasterWithPattern/>}/>
          <Route path="/theEdge" element={<TheEdge/>}/>
          <Route path="/unlockingMarketSecret" element={<UnlockingMarketSecret/>}/>



          <Route path="/bootstrap" element={<BootstrapCourse/>}/>
          <Route path="/c" element={<CLanguage/>}/>
          <Route path="/cpp" element={<CppLanguage/>}/>
          <Route path="/webdesign" element={<WebDesign/>}/>
          <Route path="/webdevelopment" element={<FullStackWebDevelopment/>}/>
          <Route path="/react" element={<ReactCourse/>}/>
          <Route path="/mernstack" element={<MernStack/>}/>
          <Route path="/meanstack" element={<MeanStack/>}/>
          <Route path="/python" element={<Python/>}/>
          <Route path="/java" element={<CoreJava/>}/>
          <Route path="/javascript" element={<JavaScript/>}/>
          <Route path="/dsawithcpp" element={<DsaWithCpp/>}/>
          <Route path="/databasemanagement" element={<DatabaseManagementMongoDB/>}/>
          <Route path="/networking" element={<ComputerNetworking/>}/>

          <Route path="/basicCourse" element={<BasicCourse/>}/>
          <Route path="/allCourse" element={<AllCourse/>}/>
          <Route path="/advanceCourse" element={<AdvanceCourse/>}/>
          <Route path="/intermideateCourse" element={<IntermideateCourse/>}/>
          <Route path="/technicalCourse" element={<TechnicalCourse/>}/>
          
           <Route path="investment" element={<Investment/>}/>
           <Route path="/tradingPlatform" element={<TradingPlatform/>}/>
           <Route path="/educationResource" element={<TradingEducation/>}/>
           <Route path="/webDesignAndDevelopment" element={<WebDesignAndDevelopment/>}/>
           <Route path="uiUxDesign" element={<UxDesign/>}/>
           <Route path="SEO" element={<SEO/>}/>

            <Route path="burari" element={<Burari/>}/>
            <Route path="laxminagar" element={<LaxmiNagar/>}/>

            <Route path="/aonetraning" element={<AOneTeaching/>}/>
            <Route path="/handsontraning" element={<HandsOnTraning/>}/>
            <Route path="/priceandvalue" element={<PriceAndValue/>}/>
            <Route path="/resourcematerial" element={<ResourceMaterial/>}/>
            <Route path="/experttraning" element={<ExpertTranner/>}/>
            <Route path="/innovationtechnique" element={<InnovatinTechnique/>}/>


            <Route path="/onlinemarketer" element={<OnlineMarketer/>}/>
            <Route path="/marketingmanager" element={<MarketManager/>}/>
            <Route path="/joinourteam" element={<JoinOurTeam/>}/>

            <Route path="/productAssistance" element={<ProductAssistance/>}/>
            <Route path="/technicalAssistance" element={<TechnicalAssistance/>}/>
            <Route path="/clintServices" element={<ClintService/>}/>
         </Routes>

          <InquiryFormPopup/>
       </BrowserRouter>
   </>
  );
}

export default App;
